import React, { useEffect, useMemo, useState } from "react";
import { ListProductUseCase } from "../../../Usecase/Products/list-product-usecase";
import { useToast } from "../../../Hooks/ToasContext";
import { IProductEntity } from "../../../Services/api/products/products.interface";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import queryString from 'query-string';

import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitHandler, useForm } from "react-hook-form";
import * as Yup from 'yup'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IArtEntity, ICreateArtPayload, IUpdateArtPayload } from "../../../Services/api/arts/arts.interface";

import { CreateArtsUseCase } from "../../../Usecase/Arts/create-arts-usecase";
import { ShowArtsUseCase } from "../../../Usecase/Arts/show-arts-usecase";
import { ICustomerEntity } from "../../../Services/api/customers/customers.interface";
import { ShowCustomersUseCase } from "../../../Usecase/Customers/show-customers-usecase";
import { ShowProductUseCase } from "../../../Usecase/Products/show-product-usecase";
// import { UpdateArtsUseCase } from "../../../Usecase/Arts/update-arts-usecase";

interface IUseCreateArtsProps {
    createArtsUseCase: CreateArtsUseCase
     showArtsUseCase: ShowArtsUseCase
     showCustomersUseCase: ShowCustomersUseCase
      showProductUseCase: ShowProductUseCase
    //  updateArtsUseCase: UpdateArtsUseCase
}

const CreateArtSchemaValidation = Yup.object().shape({
  artLink: Yup.string().required('URL da arte é obrigatório'),
  });


interface IArtProps {
	artLink: string
	
}

export function useCreateArts({ createArtsUseCase, showArtsUseCase, showCustomersUseCase, showProductUseCase }: IUseCreateArtsProps){
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<IArtEntity>()
    const [showCustomersModal, setShowCustomersModal] = useState(false)
    const [showProductsModal, setShowProductsModal] = useState(false)
    const [customerSelected, setCustomerSelected] = useState<ICustomerEntity>()
    const [productSelected, setProductSelected] = useState<IProductEntity>()
    const location = useLocation()
    const params = useParams()
    
    const navigate = useNavigate()
    const parsed = queryString.parse(location.search);

    const { handleSubmit, register, control, formState, setValue } = useForm<IArtProps>({
        resolver: yupResolver(CreateArtSchemaValidation),
      });

      const { errors } =  formState

    const { showToast } =  useToast()

    const listArts = async (boxId: string) => {
        
        try {
          setLoading(true)
          
          const showResult = await showArtsUseCase.handle(boxId);

          if (showResult.isFailure) {
            showToast(String(showResult?.error?.error), 'error');
            return;
          }

         const box = showResult.getValue()

         

        } catch (error) {
          console.log("error listArts function: ", error)
        } finally {
          setLoading(false);
        }
      };

    const showCustomer  = async (customerId: string) => {
      
      try {
        setLoading(true)
        
        const showResult = await showCustomersUseCase.handle(customerId);

        if (showResult.isFailure) {
          showToast(String(showResult?.error?.error), 'error');
          return;
        }

        const customer = showResult.getValue()

        if(customer?.id){
          setCustomerSelected(customer)
        }

        

      } catch (error) {
        console.log("error listArts function: ", error)
      } finally {
        setLoading(false);
      }
    }; 

    const showProduct  = async (productId: string) => {
      
      try {
        setLoading(true)
        
        const showResult = await showProductUseCase.handle(productId);

        if (showResult.isFailure) {
          showToast(String(showResult?.error?.error), 'error');
          return;
        }

        const product = showResult.getValue()

        if(product?.id){
          setProductSelected(product)
        }

        

      } catch (error) {
        console.log("error listArts function: ", error)
      } finally {
        setLoading(false);
      }
    }; 


    const handleAction: SubmitHandler<IArtProps> = async (values) => {
        console.log("values: ", values)
        try {
          setLoading(true)

          if(!productSelected?.id){
            showToast('Selecione o Produto', 'error');
            setLoading(false)
            return;
          }

          if(!customerSelected?.id){
            showToast('Selecione o Cliente', 'error');
            setLoading(false)
            return;
          }

          const payloadCreate: ICreateArtPayload  = {
            ...values,
            productId: productSelected.id,
            customerId: customerSelected.id,
          }

          const payloadUpdate: IUpdateArtPayload  = {
            ...values,
            productId: productSelected.id,
            customerId: customerSelected.id,
            id: String(params.id)
          }

          console.log("payloadUpdate: ", payloadUpdate)

        
          // const storeResult = params.id ? await updateArtsUseCase.handle(payloadUpdate) :  await createArtsUseCase.handle(payloadCreate);
          const storeResult =  await createArtsUseCase.handle(payloadCreate);

          if (storeResult.isFailure) {
            
            showToast(String(storeResult?.error?.error), 'error');
            return;
          }

          showToast(params.id ? 'Arte Atualizada' : 'Arte Cadastrada', 'success')
          navigate('/arts-list');

        } catch (error) {
            console.log("error: ", error)
            showToast(error.response?.data?.error ?? 'Erro. Por favor, tente novamente', 'error');
          // toast({
          //   position: 'top-right',
          //   render: () => <ToastCustom type='fail' title='Erro' description={error.response?.data?.error ?? 'Erro ao logar. Por favor, tente novamente'} />,
          // });
        } finally {
          setLoading(false);
        }
      };

  
    useEffect(() => {
      if(params.id){
        listArts(params.id)
      }
    },[])

    const handleSelectCustomer = (customer: ICustomerEntity) => {
      setCustomerSelected(customer)
      setShowCustomersModal(false)
    }

    const handleSelectProduct = (product: IProductEntity) => {
      setProductSelected(product)
      setShowProductsModal(false)
    }

    useEffect(() => {
      if(parsed?.customerId){
        showCustomer(parsed.customerId as string)
      }

      if(parsed?.productId){
        showProduct(parsed.productId as string)
      }
      
    }, [])

    


      

    return {
        loading,
        handleSubmit,
        handleAction,
        register,
        setShowCustomersModal,
        showCustomersModal,
        errors,
        data,
        setCustomerSelected,
        customerSelected,
        handleSelectCustomer,
        handleSelectProduct,
        setShowProductsModal,
        showProductsModal,
        productSelected
        
        
    }
}